<template>
	<svg :viewBox="viewBox" :width="svgWidth * svgScale" :height="svgHeight * svgScale">
		<defs>
		<pattern
			id="holes_bg"
			width="5"
			height="5"
			patternUnits="userSpaceOnUse"
			patternContentUnits="userSpaceOnUse"
		>
			<rect
			x="0"
			y="0"
			:width="rackWidth"
			:height="rackWidth"
			fill="#c4c6c8"
			/>
			<rect
			x="2.3"
			y="3.85"
			width="1.15"
			height="1.15"
			fill="white"
			/>
		</pattern>
		<pattern
			id="holes"
			width="5"
			height="5"
			patternUnits="userSpaceOnUse"
			patternContentUnits="userSpaceOnUse"
		>
			<rect
			x="2.3"
			y="3.85"
			width="1.15"
			height="1.15"
			fill="white"
			/>
		</pattern>
		</defs>
		<g v-for="(el, i) in stack" :key="i" :is="el.type" v-bind="el.props"></g>
	</svg>
</template>

<script>
	import Link from './shelving/Link';
	import Rack from './shelving/Rack';
	import Shelf from './shelving/Shelf';
	import ShelfGrid600 from './shelving/ShelfGrid600';
	import ShelfGrid800 from './shelving/ShelfGrid800';
	import ShelfGrid1000 from './shelving/ShelfGrid1000';
	import Screens from './shelving/Screens';

	export default {
		name: 'ShelvingSVG',
		props: {
			separate: {
				type: Boolean,
				default: true,
			},
			rowAccessories: {
				type: Object,
				default: () => {},
			},
			sections: {
				type: Array,
				default: () => [],
			},
			rackWidth: {
				type: Number,
				default: 5.6,
			},
			depth: {
				type: Number,
				default: 40,
			},
			height: {
				type: Number,
				default: 200,
			},
			svgScale: {
				type: Number,
				default: 1,
			},
			scale: {
				type: Number,
				default: 1,
			},
		},
		computed: {
			viewBox() {
				return `0 0 ${this.svgWidth} ${this.svgHeight}`;
			},
			svgWidth() {
				return this.sectionsWidth + this.depthOffset.x;
			},
			svgHeight() {
				return this.scaledHeight + this.depthOffset.y;
			},
			scaledHeight() {
				return this.height * this.scale;
			},
			sectionsWidth() {
				return this.sections.reduce((a, c) => a + c.width * this.scale, 0) + (this.sections.length + 1) * this.rackWidth;
			},
			rackOffset() {
				return {
					x: this.rackWidth / 1.8,
					y: this.rackWidth / 3,
					width: this.rackWidth,
					height: 2.4,
				};
			},
			depthOffset() {
				return {
					x: this.depth / 10 / 1.8,
					y: this.depth / 10 / 3,
				};
			},
			stack() {
				const stack = [];
				
				const addRacks = (x) => {
					// back
					stack.push({
						type: 'Rack',
						props: {
							x: x + this.depthOffset.x - this.rackOffset.x,
							y: this.rackOffset.y,
							width: this.rackWidth,
							height: this.scaledHeight,
						},
					});

					// top
					stack.push({
						type: 'Link',
						props: {
							x: x,
							y: this.depthOffset.y + 6,
							height: 2.6,
							rackOffset: this.rackOffset,
							depthOffset: this.depthOffset,
						},
					});

					// bottom
					stack.push({
						type: 'Link',
						props: {
							x: x,
							y: this.depthOffset.y + this.scaledHeight - 13,
							height: 2.6,
							rackOffset: this.rackOffset,
							depthOffset: this.depthOffset,
						},
					});

					stack.push({
						type: 'Link',
						props: {
							x: x,
							y: this.depthOffset.y + this.scaledHeight - 35,
							deltaY: -50,
							height: 4,
							rackOffset: this.rackOffset,
							depthOffset: this.depthOffset,
						},
					});

					stack.push({
						type: 'Link',
						props: {
							x: x,
							y: this.depthOffset.y + this.scaledHeight - 185,
							deltaY: 90,
							height: 4,
							rackOffset: this.rackOffset,
							depthOffset: this.depthOffset,
						},
					});

					// front
					stack.push({
						type: 'Rack',
						props: {
							x: x,
							y: this.depthOffset.y,
							width: this.rackWidth,
							height: this.scaledHeight,
						},
					});
				};

				const addScreens = (props) => {
					stack.push({
						type: 'Screens',
						props: {
							depthOffset: this.depthOffset,
							...props,
						},
					});
				};

				const addShelfs = (x, width, shelfCount, parts, accessories, shelvesType, isFirst, isLast) => {
					for (let i = shelfCount - 1; i >= 0; i--) {
						const y = this.getShelfY(shelfCount, i)
						stack.push({
							type: shelvesType === 'Сетчатые' ? 'ShelfGrid' + this.depth : 'Shelf',
							props: {
								x: x,
								y: y,
								width: width,
								parts: parts,
								rackOffset: this.rackOffset,
								depthOffset: this.depthOffset,
								isFirst: isFirst,
							},
						});
					}
				};
				const addShelfLeftScreens = (offsetX, section, index, dx, dy) => {
					for (let i = section.count - 1; i >= 0; i--) {
						const isTop = (i === 0);
						const padTop = 15;
						const padBottom = 28;
						const stepY = (this.scaledHeight - padTop - padBottom) / (section.count - 1);
						const y = this.depthOffset.y + padTop + stepY * i
						if (!isTop) {
							const accessories = this.getAccessories(section, index)
							if (accessories.side_screen && accessories.side_screen_left_count >= i) {
								addScreens({
									x: offsetX + dx,
									y: y + dy,
									width: this.getPrintSectionWidth(section, index),
									left: true,
									right: false,
								});
							}
						}
					}
				}
				const addShelfRightScreens = (offsetX, section, index, dx, dy) => {
					for (let i = section.count - 1; i >= 0; i--) {
						const isTop = (i === 0);
						const y = this.getShelfY(section.count, i)
						if (!isTop) {
							const accessories = this.getAccessories(section, index)
							if (accessories.side_screen && accessories.side_screen_right_count >= i) {
								addScreens({
									x: offsetX + dx,
									y: y + dy,
									width: this.getPrintSectionWidth(section, index),
									left: false,
									right: true,
								});
							}
						}
					}
				}
				const addShelfBackScreens = (offsetX, section, index, dx, dy) => {
					for (let i = section.count - 1; i >= 0; i--) {
						const isTop = (i === 0);
						const y = this.getShelfY(section.count, i)
						if (!isTop) {
							const accessories = this.getAccessories(section, index)
							if (accessories.back_screen && section.count - accessories.back_screen_count <= i) {
								addScreens({
									x: offsetX + dx,
									y: y + dy,
									width: this.getPrintSectionWidth(section, index),
									back: true,
								});
							}
						}
					}
				}

				let offsetX = 0;
				addShelfLeftScreens(offsetX, this.sections[0], 0, 2.6, 1)
				addRacks(offsetX);
				this.sections.forEach((section, index) => {
					offsetX += this.rackWidth;
					const isFirst = index === 0
					const isLast = index === this.sections.length - 1
					addShelfBackScreens(offsetX, section, index, 0, 0)
					addShelfs(offsetX, this.getPrintSectionWidth(section, index), section.count, section.parts, this.getAccessories(section, index), section.shelvesType, isFirst, isLast);
					offsetX += this.getPrintSectionWidth(section, index);
					addRacks(offsetX, section);
					addShelfRightScreens(offsetX, section, index, - this.getPrintSectionWidth(section, index) + this.rackWidth, 0)

					if (this.separate && !isLast) {
						addShelfLeftScreens(offsetX, this.sections[index + 1], index + 1, 6, 3)
					}
					if (this.separate && !isLast) {
						offsetX += this.rackWidth + 2;
						addRacks(offsetX, section);
					}
				});

				return stack;
			},
		},
		methods: {
			getRowSideScreenLeftCount() {
				const last_count = this.sections[this.sections.length - 1].count - 1;
				const screen_count = +this.rowAccessories.side_screen_count;
				
				return screen_count + (last_count < screen_count ? screen_count - last_count : 0);
			},
			getRowSideScreenRightCount() {
				const first_count = this.sections[0].count - 1;
				const screen_count = +this.rowAccessories.side_screen_count;

				return screen_count + (first_count < screen_count ? screen_count - first_count : 0);
			},
			getAccessories(section, index) {
				const isFirst = index === 0
				const isLast = index === this.sections.length - 1
				let row_side_screen_left_count = this.getRowSideScreenLeftCount()
				let row_side_screen_right_count = this.getRowSideScreenRightCount()
				if (!this.separate) {
					row_side_screen_left_count = isFirst ? row_side_screen_left_count : 0
					row_side_screen_right_count = isLast ? row_side_screen_right_count : 0
				}
				const accessories = {
					...section.accessories,
					side_screen: (this.separate ? section.accessories.side_screen : this.rowAccessories.side_screen),
					side_screen_left_count: (this.separate ? section.accessories.side_screen_count : row_side_screen_left_count),
					side_screen_right_count: (this.separate ? section.accessories.side_screen_count : row_side_screen_right_count),
				};

				return accessories
			},
			getPrintSectionWidth(section, index) {
				let printSectionWidth = section.width * this.scale

				return index > 0 ? printSectionWidth - this.rackWidth -2 : printSectionWidth;
			},
			getShelfY(shelfCount, i) {
				const padTop = 15;
				const padBottom = 28;
				const stepY = (this.scaledHeight - padTop - padBottom) / (shelfCount - 1);

				return this.depthOffset.y + padTop + stepY * i
			}
		},
		components: {
			Link,
			Rack,
			Shelf,
			ShelfGrid600,
			ShelfGrid800,
			ShelfGrid1000,
			Screens,
		},
	}
</script>

<style>

</style>